<template>
  <div
    v-if="visible"
    class="fixed bottom-4 left-1/2 z-[1000] w-[calc(100%-1.5rem)] max-w-2xl -translate-x-1/2 rounded-2xl border border-zinc-200 bg-white/95 px-4 py-3 shadow-2xl backdrop-blur"
  >
    <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p class="text-sm font-semibold text-zinc-900">Privacidade e consentimento</p>
        <p class="text-sm text-zinc-600">
          Usamos cookies para entender como você chegou até aqui. Ao continuar, você concorda com a
          <a
            :href="`${appUrl}/privacidade`"
            class="font-medium text-primary-600 underline"
            @click="onPrivacyClick"
          >Política de Privacidade</a>.
        </p>
      </div>
      <button
        class="rounded-full bg-primary-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-700 shrink-0"
        @click="accept"
      >
        Entendi
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { appUrl } from '../../content/landingContent.js'
import { useLegalModal } from '../../composables/useLegalModal.js'

const CONSENT_KEY = 'avance-landing-consent'
const visible = ref(!localStorage.getItem(CONSENT_KEY))

const { openLegalModal } = useLegalModal()

const onPrivacyClick = (event) => {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
  event.preventDefault()
  openLegalModal('privacy')
}

function accept() {
  localStorage.setItem(CONSENT_KEY, 'true')
  visible.value = false
}
</script>
